<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">
            {{
              tipo === 1
                ? `Cadastrar Posto de Trabalho`
                : `Editar Posto de Trabalho`
            }}
          </h4>

          <div class="col-12">
            <FormPostoTrabalho
              :tipo="tipo"
              :posto="posto"
              :isLoading="isLoading"
              @salvarPostoTrabalho="salvarDados"
            />
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import Fuse from "fuse.js";
import NotificationHorarioLimite from "../Notifications/NotificationHorarioLimite.vue";

import FormPostoTrabalho from "./FormPostoTrabalho.vue";
import jwt from "jsonwebtoken";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
    FormPostoTrabalho,
  },
  data() {
    return {
      tipo: "",
      posto: "",
      isLoading: false,
    };
  },
  created() {
    this.carregarDados();
  },
  mounted() {},
  methods: {
    notifyVue(verticalAlign, horizontalAlign) {
      this.$notify({
        component: NotificationHorarioLimite,
        icon: "tim-icons icon-bell-55",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "warning",
        timeout: 30000,
      });
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    carregarDados() {
      const th = this;
      this.tipo = Number(this.$route.params.tipo);

      if (this.tipo === 2) {
        jwt.verify(this.$route.params.token, "qXTflPwOaD", function(
          err,
          decoded,
        ) {
          if (decoded) {
            th.posto = decoded.data;
          }
        });
      }
    },

    salvarDados(event) {
      const th = this;
      this.isLoading = true;
      let url = `/api/empregador/cadastrarEmpregador`;
      let msg = `cadastrar`;
      event.setDB = this.$cookies.get("db");

      if (this.tipo === 2) {
        url = `/api/empregador/editarEmpregador`;
        msg = `editar`;
      }

      this.axios
        .post(url, event, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          console.log(response);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Sucesso",
            `Sucesso ao ${msg} posto de trabalho!`,
            "success",
          );

          th.$router.push("/postosTrabalho");
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            `Erro ao ${msg} posto de trabalho!`,
            "error",
          );
        });
    },
  },
  watch: {},
};
</script>
<style>
.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}
</style>
